
(function (Drupal, $, window) {

  Drupal.behaviors.basic = {
    attach: function (context, settings) {

    	$('[data-iframe-embed]').click(function(e) {
    		e.preventDefault();
    		var $t = $(this);		

    		var url = $t.data('iframe-embed');
    		if (url != '') {
    			url += "?autoplay=1&title=0&badge=0&byline=0&portrait=0"
                $t.data('iframe-embed', '');

    			var $iframe = $('<div class="responsive-embed"></div>').hide();
    			
    			var $p = $t.parents('.page-wrapper').find('.'+$t.data('prepend')).first();
    			var y = $p.offset().top-30;
    			
    			$p.prepend($iframe);
    			$iframe.html('<iframe seamless allowfullscreen frameborder="0" src="'+url+'" />');
    			$iframe.slideDown(333);
    			
    			$('html, body').animate({scrollTop: y}, 333);
    		}
    	});

        $('.collapsed').addClass('hide').hide();

        $('[data-collapse]').click(function(event) {
            event.preventDefault();
            var $t = $(this);       

            var el = $t.data('collapse');
            var $el = $(el);
            $t.fadeTo(333, 0);
            $el.removeClass('hide').slideDown(333, function() {

            });
        });

        
        $(once('collapse-title', '.collapse-title', context)).each(function () {        
            //event.preventDefault();
            $(this).on('click', function(e) {
              var $t = $(this);               
              var $el = $t.next();

              if ($t.hasClass('closed')) {
                $el.removeClass('hide').slideDown(250);                
                $t.removeClass('closed');
              } else {
                $el.slideUp(125, function() {
                  $el.hide().addClass('hide');
                  $t.addClass('closed');
                });
              }
              return true;
            });              
        });    
        

        $('.section-user form').each(function() {
          var $f = $(this);
          $f.find('input,select').change(function() {
            $f.find('#edit-submit').removeClass('disabled');
          });
          $f.find('#edit-submit').click(function(e) {
            if ($(this).hasClass('disabled')) {
              e.preventDefault();
            }
            $(this).addClass('disabled');
          });
        }); 


        // enable tabs
        $('.view-ajax-args-toggle').each(function(e) {
          var $t = $(this);
          var $view = $t.parents('.view');  
          if (jQuery.isEmptyObject(Drupal.views.instances)) {
            $t.find('[data-arg]').first().addClass('is-active');            
            return false;
          }

          $.each( Drupal.views.instances , function getInstance( index, instance) {                                    
              if($(instance.refreshViewAjax.selector)[0] == $view[0]) {                 
                  var active = instance.settings.view_args;  
                  // assumption, if more than one view arg, use the LAST view arg. Assuming this is a filter at the end of a chain of other contextual filters                 
                  if (instance.settings.view_args.indexOf('/') != -1) {
                    n = instance.settings.view_args.lastIndexOf('/');
                    active = instance.settings.view_args.substring(n + 1);
                  } 

                  $t.find('[data-arg="'+active+'"]').addClass('is-active');
                  return true;
              }
          });
        });


        // Move images from recipe into hero
        if ($('.swiper-full .swiper-wrapper')[0]) {
            $('.field--name-field-recipe img').each(function() {
                var $t = $(this);
                var url = $t.attr('src');
                url = url.replace('/sites/default/files/', '/sites/default/files/styles/fullscreen_banner/public/');
                var $fig = $('<figure class="swiper-slide"><img src="'+url+'" /></figure>');

                $('.swiper-full .swiper-wrapper').append($fig);
                $t.remove();
            });
        }

        $('.mobile-nav').click(function() {
          var $head = $('#site-header');
          if ($head.hasClass('active')) {
            $head.find('.footer-items').remove();
          } else {
            var fc = $('.footer-top .columns').html();
            var $fi = $('<div class="footer-items"><div class="outer-wrapper">'+fc+'</div></div>');            
            $head.find('.header-bottom').append($fi);
          }
          $head.toggleClass('active');
        })

        $('.swiper-component').each(function() {
          var $t = $(this);
          var $nextEl = $t.find('.swiper-button-next');
          var $prevEl = $t.find('.swiper-button-prev');
          var $pagination = $t.find('.swiper-pagination');

          var paginationEl = $pagination[0] ? $pagination[0] : null;

          var swiper = new Swiper($(this).find('.swiper-container')[0], {
            // Optional parameters
            direction: 'horizontal',
            // loop: true,
            slidesPerView: 'auto',
            wrapperClass: 'swiper-wrapper',
            mousewheel: false,
            updateOnImagesReady: false,
            //cssMode: true,

            // If we need pagination
            pagination: {
              el: paginationEl//'.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
              nextEl: $nextEl[0],//'.swiper-button-next',
              prevEl: $prevEl[0],//'.swiper-button-prev',
            },

            
          });
        });

        var showTabContent = function($t) {
          var $tabContent = getContentTabTarget($t);
          $t.addClass('is-active');
          $tabContent.show();
        }

        var hideTabContent = function($t) {
          var $tabContent = getContentTabTarget($t);
          $t.removeClass('is-active');
          $tabContent.hide();
        }

        var getContentTabTarget = function($t) {
          var $scope = $t.parents('article');
          if (!$scope[0]) {
            $scope = $t.parents('.content');
          }
          if ($t.data('target')) {
            return $scope.find('[data-tab="'+$t.data('target')+'"]');
          } else if ($t.data('class')) {
            return $scope.find('.tab-content.'+$t.data('class'));
          }
        }

        $('body').on('click', '[data-show-target]', function(e) {
          e.preventDefault();
          var $tab = $(this);
          $tab.closest('.content').find('[data-show-id="'+$tab.data('show-target')).show();
          $tab.hide();
        });


        $('body').on('click', '.view-ajax-args-toggle [data-arg]', function(e) {
          e.preventDefault();
          var $tab = $(this);
          
          if ($tab.hasClass('is-active')) {
            return;
          }

          $tab.parents('.view-ajax-args-toggle').find('.is-active').removeClass('is-active');
          $tab.addClass('is-active');

          var $view = $tab.parents('.view');
          $.each( Drupal.views.instances , function getInstance( index, instance) {            
                if(instance.$view[0] == $view[0]) {
                    // assumption, if more than one view arg, edit the LAST view arg. Assuming this is a filter at the end of a chain of other contextual filters                 
                    if (instance.settings.view_args.indexOf('/') != -1) {
                      n = instance.settings.view_args.lastIndexOf('/');
                      instance.settings.view_args = instance.settings.view_args.substring(0, n) + "/" + $tab.data('arg');                      
                    } else {
                      instance.settings.view_args = $tab.data('arg');                      
                    }

                    $view.trigger('RefreshView');
                    return;
                }
            });
        });


        $('body').on('click', '.refresh-view', function(e) {
          e.preventDefault();
          var $tab = $(this);                    
          var $view = $tab.closest('.view');

          if ($tab.hasClass('refresh-filters')) {
            $view.find('.view-filters form .js-form-submit').first().trigger('click');
          } else {
            $view.trigger('RefreshView');            
          }

        });

        


        $('body').on('click', '.content-tabs a, .content-tabs button, .content-tabs li span', function(e) {
          e.preventDefault();
          var $tab = $(this);                   
          if ($tab.hasClass('is-active')) {
            return;
          }

          var $tabs = $tab.parents('.content-tabs');    
          var $current = $tabs.find('.is-active');

          if (!$current[0]) {
            var $old = $tabs.find('a, .tab').not($tab);
            $old.each(function() {                          
              hideTabContent($(this));
            });
          } else {
            hideTabContent($current); 
          }

          showTabContent($tab);

        });

        var hash = window.location.hash.substr(1);
        if (hash) {
          if ($('.content-tabs')[0]) {
            $tab = $('.content-tabs a[data-class="tab-'+hash+'"]');
            if ($tab[0]) {
              $tab.trigger('click');
            }
          }  
        }
        
        // check anchor for tabs
        
        /*
        $('.content-tabs a, .content-tabs button').each(function() {
          var $tabContent = getContentTabTarget($(this));
          if (!$tabContent[0]) {
            $(this).hide();
          }
        });
        */

        $('#my-diet-load').click(function(evt) {
          evt.preventDefault();
          var $t = $(this);
          $t.addClass('click');
          var $form = $(this).parents('form');

          var diets = $t.data('diet');                          
          if (diets) {
            // clear values from initial diet form element
            var $diet = $form.find('#edit-diet');//.next('.select2');
            $diet.find('option:selected').removeAttr('selected');
            for (var d in diets) {              
              $diet.find('option[value="'+diets[d]+'"]').prop('selected', 'selected');              
            }
            $diet.trigger('change');
          }

          var ingredients_avoid = $t.data('ingredients-avoid');  
          if (ingredients_avoid) {
            // clear values from initial diet form element, tricky cause its ajax populated
            var $ingfield = $(this).parents('form').find('#edit-ingredients-avoid');
            $ingfield.find('option').remove();
            $ingfield.trigger('change');
            
            // programatically set options, in future add title in if available in data-attr
            for (var i in ingredients_avoid) {
              var option = new Option('... ', ingredients_avoid[i], true, true);
              $ingfield.append(option);              
            }

            //$ingfield.trigger('change');
            // manually trigger the `select2:select` event
            /*
            studentSelect.trigger({
                type: 'select2:select',
                params: {
                    data: data
                }
            });
            */
          }   

          var ingredients_allow = $t.data('ingredients-allow');  
          if (ingredients_allow) {
            // clear values from initial diet form element, tricky cause its ajax populated
            var $ingfield = $(this).parents('form').find('#edit-ingredients-allow');
            $ingfield.find('option').remove();
            $ingfield.trigger('change');
            
            // programatically set options, in future add title in if available in data-attr
            for (var i in ingredients_allow) {
              var option = new Option('... ', ingredients_allow[i], true, true);
              $ingfield.append(option);              
            }

            
          }  

          $form.submit();    

        });


        $('.view-recipes .views-exposed-form').each(function() {
          if (!$('body').hasClass('user-logged-in') || $('body').hasClass('user-not-sub')) {

            var $t = $(this);            
            var $first = $t.find('input,select,details').not('.form-text,.form-submit').prop('disabled', true).addClass('disabled').first();

            $t.find('.form-submit').each(function() {

              $first.before($(this));
            })

            var text = $('body').hasClass('user-not-sub') ? 
              '<p class="form-alert">Please <a href="/stripe_registration/subscribe">upgrade</a> your account to use advanced search.</p>' :
              '<p class="form-alert">Please log in to use advanced search.</p>';

            $first.before(text);
          }
        });


        // MODIFY meal plan paragraphs with modification query param onto node
        $('.paragraph--type--meal[data-m]').each(function() {
          var $t = $(this);
          var m = $t.data('m');
          var ml = $t.data('ml');

          var $links = $t.find('.node--type-recipe').not('.contextual').find('a');
          $links.attr('href', $links.attr('href')+'?m='+m);

          var $title = $t.find('.node-title a');
          $title.html($title.html()+' <em>('+ml+')</em>');

        });

        $('body:not(.user-logged-in) a[href="/user"], body:not(.user-logged-in) a[href="/user/login"]').click(function(e) {
          e.preventDefault();

          var url = $(this).attr('href');
          if (window.location.pathname) {
            url += '?destination='+window.location.pathname;
          }
          window.location = url;
        });

        /*
        // Full calendar JS stuff placed here for convienence, should be packaged into a library eventually
        const calendarObserver = new MutationObserver(function(mutations_list) {
          mutations_list.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(added_node) {
              console.log(added_node);
              if(added_node.className == 'fc-view-container') {
                var $calEl = $(added_node).parents('.js-drupal-fullcalendar');
                calendarObserver.disconnect();
                modifyFullCalendar($calEl);
              }
            });
          });
        });

        console.log(document.querySelector(".view-nm-calendar"));

        calendarObserver.observe(
          document.querySelector(".view-nm-calendar"), 
          { 
            subtree: false, 
            childList: true 
          }
        );
        */

        

    }
  };

} (Drupal, jQuery, this));
